import type { HostAttributeMeta } from '@/admin/types/hosts'
import { isValueFilled } from './wizard-validation'

/**
 * Required host attributes that are still empty.
 *
 * The host step's Continue gate and its per-field errors both read this, so a
 * blocked Continue always names the field that is missing. `skip` holds
 * code_names another widget owns (e.g. the structure picker). "Empty" follows
 * the wizard's shared `isValueFilled`, so an empty list or a blank string
 * counts as missing here exactly as it does on every other step.
 */
export function missingRequiredHostAttributes(
  attributes: HostAttributeMeta[],
  values: Record<string, unknown>,
  skip: ReadonlySet<string> = new Set(),
): HostAttributeMeta[] {
  return attributes.filter(
    (attr) =>
      attr.required && !skip.has(attr.code_name) && !isValueFilled(values[attr.code_name]),
  )
}

/** `{code_name: message(label)}` for each missing attribute. */
export function requiredHostAttributeErrors(
  missing: HostAttributeMeta[],
  message: (label: string) => string,
): Record<string, string> {
  return Object.fromEntries(
    missing.map((attr) => [attr.code_name, message(attr.display_name)]),
  )
}
